module.exports = __webpack_public_path__ + "prs-banner.jpg?ca122aa0a007f4fd6d21d1e8fb7d2823";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prs-banner.jpg
// module id = 244
// module chunks = 0